import React, { useEffect, useState } from 'react'
import FormComponent from '../../generic-components/formComponent/FormComponent'
import { useForm } from 'react-hook-form';
import ClayLayout from '@clayui/layout';
import {  personalAndContactProfileDetails } from '../../config';
import CutButton from '../../generic-components/customCutButton/CutButton';
import "./Profile.css"
import ComponentHeader from '../../generic-components/ComponentHeader/ComponentHeader';
import { useApiAuthMutationDynamic } from '../../apis/useApi';
import { toast } from 'react-toastify';
import ClayLoadingIndicator from '@clayui/loading-indicator';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
    const {
        control: controlBasic,
        register: registerBasic,
        watch: watchBasic,
        handleSubmit: handleSubmitBasic,
        setError: setErrorBasic,
        setValue: setValueBasic,
        formState: { errors: errorsBasic }
    } = useForm({ mode: 'all' });

    // Form 2 — Business Info
    const {
        control: controlBusiness,
        register: registerBusiness,
        watch: watchBusiness,
        handleSubmit: handleSubmitBusiness,
        setError: setErrorBusiness,
        setValue: setValueBusiness,
        formState: { errors: errorsBusiness }
    } = useForm({ mode: 'all' });
    const [dropdownOptions, setDropdownOptions] = useState<any>({});
    const [isBasicInfoExpand, setIsBasicInfoExpand] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const matchMakingId = 803888
    const navigate = useNavigate()

    const industryVertical = watchBusiness("requestorIndustryVertical")
    const businessModelType = watchBusiness("requestorBusinessModelType")

    const todaysSellInDubaiOrUAE = watchBusiness("requestorAnswerForTodaysSellInDubaiOrUAE")
    const reachedOutThemInPast = watchBusiness('requestorReachedOutThemInPast')
    const categoriesToBeConnected = watchBusiness('requestorWantedCategoriesToBeConnected')
    const areReadyToOpenCompany = watchBusiness('howRequestorAreReadyToOpenCompany')
    const biggestChallangesInUAEStratup = watchBusiness('requestorBiggestChallangesInUAEStratup')
    const whereYourCompanyHearAboutBIDProgram = watchBasic("whereYourCompanyHearAboutBIDProgram")
   
    const themeDisplay = (window as any).Liferay?.ThemeDisplay;
  useEffect(() => {
        setValueBasic("requestorFirstName", themeDisplay?.getUserName()?.split(" ")[0])
        setValueBasic("requestorLastName", themeDisplay?.getUserName()?.split(" ")[1])
        setValueBasic("requestorWorkEmail", themeDisplay?.getUserEmailAddress())},[])


    const newPersonalAndContactDetails = personalAndContactProfileDetails?.filter((field) => {
        if (field?.name === "otherValueForBIDProgramReference") {
            return whereYourCompanyHearAboutBIDProgram === "others";
        }
        return true
    })

    useEffect(() => {
        if (whereYourCompanyHearAboutBIDProgram && whereYourCompanyHearAboutBIDProgram !== "others") {
            setValueBasic("otherValueForBIDProgramReference", "")
        }
    }, [whereYourCompanyHearAboutBIDProgram])

    useEffect(() => {
        if (industryVertical && industryVertical !== "others")
            setValueBusiness("otherIndustryVertical", "")
        if (businessModelType && businessModelType !== "others")
            setValueBusiness("otherTypeOfBusinessModel", "")
        if (todaysSellInDubaiOrUAE && todaysSellInDubaiOrUAE !== "other")
            setValueBusiness("otherAnswerForTodaySell", "")
        if (reachedOutThemInPast && reachedOutThemInPast !== "other")
            setValueBusiness("otherSpecificationForReachedOut", "")
        if (categoriesToBeConnected && !categoriesToBeConnected?.includes("others"))
            setValueBusiness("otherCategoriesWantedToConnectInDubai", "")
        if (areReadyToOpenCompany && areReadyToOpenCompany !== "other")
            setValueBusiness("otherAnswerForDubaiStartup", "")
        if (biggestChallangesInUAEStratup && !biggestChallangesInUAEStratup?.includes("other"))
            setValueBusiness("otherAnswerForChallanges", "")
    }, [industryVertical, businessModelType, todaysSellInDubaiOrUAE, categoriesToBeConnected, areReadyToOpenCompany, biggestChallangesInUAEStratup])


    const createMatchMakinRequestWithToken = useApiAuthMutationDynamic<any, {}>(
        `/o/c/matchmakingrequestors/${matchMakingId}`,
        "patch",
        {
            onSuccess: (data) => {
                toast.success("Profile Updated Successfully", {
                    theme: "light",
                    autoClose: 2000,
                });
                setIsLoading(false);
                navigate("/dashboard")
            },
            onError: (error: any) => {
                if (error?.response?.status == 400) {
                    toast.error(error?.response?.data?.title, {
                        theme: "light",
                        autoClose: 2000,
                    })
                }
                navigate("/dashboard")
                setIsLoading(false);
            },
        }
    );
    const onSubmitBasicInfo = async (data: any) => {
        setIsLoading(true)
        await createMatchMakinRequestWithToken.mutateAsync({
            data: data,
        });
    };
  
    return (
        <>
            {isLoading ? (
                <ClayLoadingIndicator displayType="secondary" size="sm" />
            ) : (
                <>
                    <form onSubmit={handleSubmitBasic(onSubmitBasicInfo)}>
                        <div className="card-body customer-profile-container">
                            <ComponentHeader
                                title="Basic Information"
                                setIsRequestedInfoExpand={setIsBasicInfoExpand}
                                isRequestedInfoExpand={isBasicInfoExpand}
                                isArrowIcon={true}
                            />
                            <div
                                className={
                                    isBasicInfoExpand ? 'expand' : 'collapse'
                                }
                            >
                                <div className="ib-hr"></div>
                                <div className="customer-profile-title-container mt-4">
                                    <h1 className="customer-profile-title px-0 m-0">
                                        Personal and Contact details
                                    </h1>
                                    <div className="ib-hr"></div>
                                </div>
                                <div className="pt-4">
                                    <ClayLayout.Row
                                        justify="start"
                                        className="content-gap"
                                    >
                                        {newPersonalAndContactDetails?.map(
                                            (data) => (
                                                <ClayLayout.Col
                                                    key={data.name}
                                                    xl={6}
                                                    lg={6}
                                                    md={6}
                                                    sm={6}
                                                    xs={12}
                                                >
                                                    <FormComponent
                                                        isPartnerType={true}
                                                        placeholder={
                                                            data.placeholder
                                                        }
                                                        label={data.label}
                                                        name={data.name}
                                                        register={registerBasic}
                                                        type={data.type}
                                                        control={controlBasic}
                                                        errors={errorsBasic}
                                                        watch={watchBasic}
                                                        setError={setErrorBasic}
                                                        errorTitle={
                                                            data.errorMessage
                                                        }
                                                        options={
                                                            dropdownOptions[
                                                                data.name
                                                            ]
                                                        }
                                                        required={data.required}
                                                        disabled={data.disabled}
                                                        component={
                                                            data.component as
                                                                | 'input'
                                                                | 'textarea'
                                                                | undefined
                                                        }
                                                    />
                                                </ClayLayout.Col>
                                            )
                                        )}
                                    </ClayLayout.Row>
                                </div>
                                <ClayLayout.ContentSection className="button-group-container mt-4 mb-0 d-flex justify-content-end">
                                    <CutButton
                                        title="Save"
                                        buttonType="submit"
                                        disabled={true}
                                    />
                                </ClayLayout.ContentSection>
                            </div>
                        </div>
                    </form>
                </>
            )}
        </>
    );
}

export default Profile